import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import SmavaLogo from 'lib/smava/Logo';

interface LogoProps {
  logoLink?: string;
}

const Logo = ({ logoLink }: LogoProps) => {
  const logoPart = (
    <Box
      sx={{
        width: 138,
      }}
    >
      <SmavaLogo />
    </Box>
  );

  if (logoLink) {
    return <Link href={logoLink}>{logoPart}</Link>;
  }

  return logoPart;
};

export { Logo };
